
import { SafeHtml } from "@angular/platform-browser";
import { AbstractDTO } from "@signature-it/ngx-generic/models";
import { DecodeBase64Pipe } from "@signature-it/ngx-generic/pipes";

export class SolrEntity extends AbstractDTO{
    date: string;
    body: SafeHtml;
    title: string;
    entity_var: string;
    description: string;
    isDisplay: boolean;
    nodeId: number;
    nodeName: string;
    typeVar: string;
    seoTitle: string;
    seoDescription: string;
    seoImage: string;
    seoUrl: string;
    uri :string;
    pageContent: string;

    constructor(attributes?: object) {
        super(attributes);
        const decodePipe = new DecodeBase64Pipe();
        attributes = attributes || {};
        Object.assign(attributes, this);

        this.date = attributes['activation_timestamp_s'] || '';
        this.body =  attributes['body_base64'] || '';
        this.title = attributes['title_s'] || '';
        this.description = attributes['summary_s'] || '';
        this.isDisplay = false;
        this.nodeId = attributes['node_id_i'] || '';
        this.nodeName = attributes['node_name_s'] || '';
        this.typeVar = attributes['entity_type_var_s'] || '';
        this.entity_var = attributes['entity_var_s'] || '';
        this.seoTitle = attributes['seo_title_s'] || '';
        this.seoDescription = attributes['seo_description_s'] || '';
        this.seoImage = attributes['seo_image_s'] || '';
        this.seoUrl = attributes['seo_url_s'] || '';
        this.uri = attributes['uri_s'] || '';
        this.pageContent = decodePipe.transform(attributes['page_content_lg']);
    }

}
